import { TabsProps } from 'antd';
import i18next from 'i18next';

export const Tokens = {
  accessToken: 'access-token',
  refreshToken: 'refresh-token'
};

export const StateCountyListLimit = 3;

export const Routes = {
  login: '/login',
  home: '/home',
  studyArea: '/studyArea',
  studyAreaCreation: '/studyArea/create',
  projects: '/projects',
  collections: '/collections',
  timeofDay: '/timeofDay',
  mapLayers: '/mapLayers',
  mapLayerCreation: '/mapLayers/create',
  zoneSystem: '/zone-system',
  zoneSystemCreation: '/zone-system/create',
  equityCreation: '/community-type/create',
  userGuides: '/userGuides',
  equity: '/community-type',
  useCases: '/useCases',
  faqs: '/faqs',
  contactSupport: '/contactSupport',
  theme: '/theme',
  features: '/features',
  projectCreation: '/projectCreation',
  addDashboard: '/addDashboard',
  users: '/users',
  organization: '/organization',
  stats: '/stats',
  profile: '/myProfile',
  guide: '/guide',
  whatsNew: '/whatsNew',
  whatsNewRelease: '/whatsNewRelease',
  clients: '/clients',
  clientCreation: '/clients/create',
  createUser: '/create-user',
  dashboard: '/dashboard',
  passenger: '/passenger',
  transit: '/transit-insights',
  truck: '/truck',
  admin: '/admin',
  data: '/data',
  person: '/person',
  perform: '/perform',
  signUp: '/signUp',
  denverPnr: '/denverpnr',
  scSelectLinkAnalysis: '/sc-analysis',
  dataRequest: '/dataRequests',
  personPlus: '/person+',
  signUpRequests: '/signUpRequests',
  resources: '/resources',
  demoVideos: '/demoVideos',
  videoWalkthrough: '/videoWalkthrough',
  dataLayer: '/dataLayer',
  dataLayerRequest: '/dataLayerRequest',
  analytics: '/analytics',
  networks: '/networks',
  networkCreation: '/networks/create',
  performanceReport: '/performanceReport',
  performanceReportView: '/performanceReportView',
  reportCreation: '/performanceReport/create',
  reportStepDataset: 'dataset',
  reportStepReport: 'report',
  reportStepDates: 'dates',
  reportStepDateAdvanced: 'date',
  reportStepTimes: 'times',
  reportStepTimeAdvanced: 'time',
  reportStepRoutes: 'routes',
  reportStepRouteAdvanced: 'route',
  reportStepArea: 'area',
  reportStepAreaAdvanced: 'shapes',
  safe: '/safe',
  selectLink: '/customo-danalytics',
  bikePedFlows: '/bike&pedflows',
  truckSelectLink: '/truck-select-link',
  parkRide: '/park&ride',
  selectLinkCreation: '/selectLink/create'
};

export const transparencyOptions = [
  { value: 0.1, label: '10%' },
  { value: 0.2, label: '20%' },
  { value: 0.3, label: '30%' },
  { value: 0.4, label: '40%' },
  { value: 0.5, label: '50%' },
  { value: 0.6, label: '60%' },
  { value: 0.7, label: '70%' },
  { value: 0.8, label: '80%' },
  { value: 0.9, label: '90%' },
  { value: 1, label: '100%' },
  { value: 0.2, label: '20%' }
];

export const pointSizeOptions = [
  { value: '2px', label: '2px' },
  { value: '4px', label: '4px' },
  { value: '6px', label: '6px' },
  { value: '8px', label: '8px' },
  { value: '10px', label: '10px' },
];

export const mapLayerShapes = {
  point: 'circle',
  line: 'line',
  polygon: 'fill'
};

export const mapLayerShapeOptions = [
  { value: 'circle', label: 'Point' },
  { value: 'line', label: 'Line' },
  { value: 'fill', label: 'Polygon' }
];

export const projectOptions: TabsProps['items'] = [
  {
    key: 'All',
    label: `${i18next.t('projects.allProjects')}`,
  },
  {
    key: 'Owned',
    label: `${i18next.t('projects.ownedProjects')}`,
  },
  {
    key: 'Shared',
    label: `${i18next.t('projects.sharedProjects')}`,
  },
];

export const enum Roles {
  SITE_ADMIN = 'SITE_ADMIN',
  CLIENT_ADMIN = 'CLIENT_ADMIN',
  USER = 'USER',
  SITE_ADMIN_R = 'SITE_ADMIN(R)'
}

export const enum LocusProducts {
  Passenger = 'Passenger',
  Charge = 'Charge',
  Perform = 'Perform',
  Safe = 'Safe',
  Truck = 'Truck',
  Transit = 'Transit',
  Transit_Insights = 'Transit Insights',
  Transit_Insights_Lite = 'Transit Insights Lite',
  Person = 'Person',
  PersonPlus = 'Person+',
  SelectLink = 'Select Link',
  BikePedFlows = 'Bike & Ped Flows',
  ParkRide = 'Park & Ride',
  CustomODAnalytics = 'Custom O-D Analytics'
}

export const enum UserActivityTypes {
  Login = 'Login',
  Logout = 'Logout',
  PopupAccess = 'PopupAccess'
}

export const StorageKeys = {
  loggedIn: 'logged-in',
  redirect: 'redirect',
  userRole: 'x-lcs-user-role',
  clientId: 'x-lcs-clientid',
  loggedInTime: 'loggedInTime'
};

export const tableTabs = {
  owned: 'Owned',
  all: 'All',
  shared: 'Shared',
  operational: 'operational'
};

export const zipFileTypes: any = [
  'application/zip',
  'multipart/x-zip',
  'application/zip-compressed',
  'application/x-zip-compressed',
  'application/x-zip',
  'application/octet-stream'
];

export const csvFileTypes: any = [
  'text/csv',
  'application/csv',
  'application/octet-stream',
  'application/vnd.ms-excel'
];

export const truckTOD = '07e5d15a-079a-4481-b1cc-42ea77d515b8';

export const enum Permissions {
  ADD_USER = 'ADD_USER',
  UPDATE_USER = 'UPDATE_USER',
  GET_USER = 'GET_USER',
  DELETE_USER = 'DELETE_USER',
  ADD_SITE_ADMIN = 'ADD_SITE_ADMIN',
  UPDATE_SITE_ADMIN = 'UPDATE_SITE_ADMIN',
  GET_SITE_ADMIN = 'GET_SITE_ADMIN',
  DELETE_SITE_ADMIN = 'DELETE_SITE_ADMIN',
  ADD_CLIENT_ADMIN = 'ADD_CLIENT_ADMIN',
  UPDATE_CLIENT_ADMIN = 'UPDATE_CLIENT_ADMIN',
  GET_CLIENT_ADMIN = 'GET_CLIENT_ADMIN',
  DELETE_CLIENT_ADMIN = 'DELETE_CLIENT_ADMIN'
}

export const messages = {
  tokenNotActive: 'Token is not active',
  refreshTokenExpired: 'Refresh token expired',
  sessionNotActive: 'Session not active',
  sessionExpired: 'Session expired',
  usernotFound: 'User not found',
  invalidRefreshToken: 'Invalid refresh token',
  jwtExpired: 'jwt expired'
};

export const displayTypes = {
  list: 'List',
  card: 'Card'
};

export const Urls = {
  stamenDevUrl: 'https://studio.stamen.com/camsys-map-prototype/show/latest/#lng=-82.69&lat=39.99&zoom=6.5&dashboard=e73a817c-2288-4f1d-99fc-675cb5d47cc7',
  zesstaPassengerDevUrl: 'https://locus-passenger-dev.zessta.com/#lng=-82.69&lat=39.99&zoom=6.5&dashboard=e73a817c-2288-4f1d-99fc-675cb5d47cc7'
};

export const timeBounds = {
  startTime: 'start-time',
  endTime: 'end-time'
};

export const pageDescription = [
  i18next.t('projects.selectDataProduct'),
  i18next.t('projects.defineStudyArea'),
  i18next.t('projects.selectTimeOfDaySegmentation'),
  i18next.t('projects.selectAdditionalAttributes'),
];

export const productDescription: any = {
  passenger: i18next.t('projects.passengerDescription'),
  charge: i18next.t('projects.chargeDescription'),
  perform: i18next.t('projects.performDescription'),
  safe: i18next.t('projects.safeDescription'),
  truck: i18next.t('projects.truckDescription'),
  transit: i18next.t('projects.transitDescription'),
  transit_insights: i18next.t('projects.transitInsightsDesc'),
  transit_insights_lite: i18next.t('projects.transitInsightsLiteDesc'),
  person: i18next.t('projects.passengerDescription'),
  'person+': i18next.t('projects.personPlusDescription')
};

export const projectCreationStepsId = {
  zoneSystem: 'zoneSystemIds',
  dashboardEquityDefinition: 'dashboardEquityDefinitionId',
  mapLayerId: 'mapLayerId'
};

export const mapLayerOptions = [
  {
    name: 'Transit Stations',
    id: '1'
  },
  {
    name: 'Bus routes',
    id: '2'
  },
  {
    name: 'Colleges/Universities',
    id: '3'
  },
  {
    name: 'Distribution centers',
    id: '4'
  }
];

export const MAPBOX_STYLE_URLS = {
  light: 'mapbox://styles/locus-cs/cllpdr7xd002o01of6pqchr55/draft',
  dark: 'mapbox://styles/locus-cs/cllpdrrc0002n01rd88nz8tf5/draft',
  street: 'mapbox://styles/mapbox/streets-v12',
  satellite: 'mapbox://styles/mapbox/satellite-streets-v12'
};

export const MAP_ACCESS_TOKEN = 'pk.eyJ1IjoibG9jdXMtY3MiLCJhIjoiY2xscDlrbmY3MDQzdTNmbzVsa2QwOXF1eSJ9.C0aPmSKbycVfCXQ3h6KcBg';

export const TOMTOM_API_KEY = '33J8BF0pEu1qh0mmTnxVxd0S0kSAtj55';

export const MAPBOX_TILESET_BLOCKGROUPS = {
  url: 'mapbox://locus-cs.6967y69s',
  layerName: 'usblockgroups',
};

export const defaultStudyAreaName = 'Untitled Study Area';

export const pointMapStyle: any = {
  'circle-color': '#532CDD',
  'circle-opacity': 1,
  'circle-radius': 3,
  'circle-stroke-color': '#532CDD'
};

export const lineMapStyle: any = {
  'line-color': '#AC29D1',
  'line-opacity': 1,
  'line-width': 2.5
};

export const polygonMapStyle: any = {
  'fill-color': '#DB47E6',
  'fill-opacity': 0.5,
  'fill-outline-color': '#000000'
};

export const accessPermissionsList = {
  share: 'share',
  delete: 'delete',
  favorite: 'favorite',
  properties: 'properties',
  addCollection: 'addCollection',
  edit: 'edit',
  changeRole: 'changeRole',
  addClient: 'addClient',
  remove: 'remove',
  removeClient: 'removeClient',
  changeName: 'changeName',
  sendMail: 'sendMail'
};

export const accessPermissions = {
  project: [accessPermissionsList.share, accessPermissionsList.favorite, accessPermissionsList.changeName, accessPermissionsList.delete, accessPermissionsList.properties],
  projectHome: [accessPermissionsList.share, accessPermissionsList.favorite, accessPermissionsList.delete, accessPermissionsList.properties],
  view: [accessPermissionsList.share, accessPermissionsList.favorite, accessPermissionsList.delete, accessPermissionsList.addCollection],
  viewHome: [accessPermissionsList.share, accessPermissionsList.favorite, accessPermissionsList.delete],
  zoneSystem: [accessPermissionsList.share, accessPermissionsList.delete],
  timePeriod: [accessPermissionsList.share, accessPermissionsList.delete],
  mapLayer: [accessPermissionsList.share, accessPermissionsList.edit, accessPermissionsList.delete],
  collectionView: [accessPermissionsList.share, accessPermissionsList.favorite, accessPermissionsList.remove],
  collection: [accessPermissionsList.share, accessPermissionsList.favorite, accessPermissionsList.delete, accessPermissionsList.edit],
};

export const publicStatus = {
  None: 'none',
  Organization: 'organization',
  Environment: 'environment'
};

export const emptyDataMessage = {
  loading: i18next.t('emptyMessages.loading'),
  timeOfDay: i18next.t('emptyMessages.emptyTimeOfDay'),
  user: i18next.t('emptyMessages.emptyUser'),
  project: i18next.t('emptyMessages.emptyProject'),
  view: i18next.t('emptyMessages.emptyView'),
  collection: i18next.t('emptyMessages.emptyCollection'),
  studyArea: i18next.t('emptyMessages.emptyStudyArea'),
  zoneSystem: i18next.t('emptyMessages.emptyZoneSystem'),
  equity: i18next.t('emptyMessages.emptyEquity'),
  client: i18next.t('emptyMessages.emptyClient'),
  mapLayer: i18next.t('emptyMessages.emptyMapLayer'),
  features: i18next.t('emptyMessages.emptyFeatures'),
  requests: i18next.t('emptyMessages.emptyRequests'),
  networks: i18next.t('emptyMessages.emptyNetworks')
};

export const favouriteToastMessage = {
  added: i18next.t('general.addedFavorites'),
  remove: i18next.t('general.removedFavorites')
};

export const accessRoles = {
  owner: 'Owner',
  viewer: 'Viewer',
  editor: 'Editor'
};

export const dashboardPendingStatus = ['In Progress', 'InProgress', 'Optimizing'];

export const maxDashboardLimit = 1000;

export const sampleFileUrls = {
  equity: 'https://camsys-data-portal.s3.amazonaws.com/sampleFiles/sampleCommunityType.csv',
  truckEquity: 'https://camsys-data-portal.s3.amazonaws.com/sampleFiles/truckSampleCommunityType.csv',
  domainList: 'https://camsys-data-portal.s3.amazonaws.com/sampleFiles/domainListExample.csv'
};

export const equityGeoTypes = {
  blockGroup: 'blockgroup',
  censusTract: 'censustract'
};

export const featureFlagKeys = {
  enableODFlowsPassenger: 'passenger.odflows.enable',
  enablePDFPassenger: 'passenger.pdf.enable',
  enableUserActivity: 'user.activity.enable',
  enableStateCountyFilter: 'dev.statecountyfilter.enable',
  enableSelectionsSync: 'dev.selectionssync.enable',
  enableClickableMap: 'dev.clickablemap.enable',
  enableODFlowsTruck: 'dev.odflows-truck.enable',
  enableMultiSelectFilter: 'dev.multiFilter.enable',
  enableColorOpactiySelection: 'dev.colorOpacity.enable',
  enableGISBuffering: 'dev.gisBuffer.enable',
  enableHideSelections: 'dev.hideSelections.enable',
  enableAggregationType: 'dev.aggregationType.enable',
  enableCustomTODTruck: 'dev.customTodTruck.enable',
  enableAdditonalInfoOnODPairs: 'dev.showAdditionalInfoOnODPairs.enable',
  enableTrendsTabs: 'dev.trends.enable',
  enableFilterMapLayers: 'dev.filterMapLayers.enable',
  enableOperationalLayers: 'dev.operationalLayer.enable',
  enablePOILayers: 'dev.poiLayer.enable',
  enableSuperset: 'dev.superset.enable',
  enableTruckAggregationType: 'dev.aggregationTypeTruck.enable',
  enableDownloadTransitStats: 'dev.downloadTransitStats.enable'
};

export const productTabKeys = {
  person: 'Person',
  transit: 'Transit',
  transitInsights: 'Transit Insights',
  transitInsightsLite: 'Transit Insights Lite',
  truck: 'Truck',
  charge: 'Charge',
  perform: 'Perform',
  safe: 'Safe',
  personPlus: 'Person+'
};

export const studyPeriodType = {
  yearly: 'yearly',
  quarterly: 'quarterly'
};

export const guideTypes = {
  dataPortal: 'dataportal',
  person: 'person',
  truck: 'truck',
  transit: 'transit'
};

export const projectCreationSteps = {
  products: 'products',
  studyArea: 'studyArea',
  dataset: 'dataset',
  transit: 'transit',
  tod: 'tod',
  attributes: 'attributes',
  modules: 'modules'
};

export const signUpRequestType = {
  userCreation: 'userCreation'
};

export const signUpRequestStatus = {
  pending: 'Pending',
  approved: 'Approved',
  reapproved: 'Reapproved',
  declined: 'Declined',
  rejected: 'Rejected',
  automated: 'Automated',
  expired: 'Expired'
};

export const fieldType = {
  input: 'input',
  textArea: 'textarea',
  date: 'date',
  select: 'select',
  phone: 'phone',
  dateRange: 'dateRange'
};

export const requestApprovalType = {
  manual: 'Manual',
  automated: 'Automated'
};

export const requestType = {
  mapData: 'Data Request',
  signUp: 'Sign Up'
};

export const modalTypes = {
  createUser: 'createUser',
  changeRole: i18next.t('users.changeRole'),
  addClient: i18next.t('users.addClientRole'),
  removeClient: i18next.t('users.removeClientRole'),
  deleteUser: 'deleteUser',
  editUser: 'editUser'
};

export const productsAccessPermissions = {
  timePeriod: [LocusProducts.Person, LocusProducts.PersonPlus, LocusProducts.Transit_Insights, LocusProducts.Transit_Insights_Lite],
  equity: [LocusProducts.Person, LocusProducts.PersonPlus, LocusProducts.Truck, LocusProducts.Transit_Insights, LocusProducts.Transit_Insights_Lite],
  projects: [
    LocusProducts.Person,
    LocusProducts.PersonPlus,
    LocusProducts.Truck,
    LocusProducts.Transit,
    LocusProducts.Transit_Insights,
    LocusProducts.Transit_Insights_Lite,
    LocusProducts.Perform
  ],
  network: [LocusProducts.Transit_Insights, LocusProducts.Transit_Insights_Lite]
};

export const quartelyDropdownLimitForYearly = 12;

export const yearsSelectionLimit = 3;

export const dropdownSelectionLimit = 5;

export const aggregationTypes = {
  yearly: 'yearly',
  quarterly: 'quarterly'
};

export const adminRoles = [
  Roles.SITE_ADMIN,
  Roles.SITE_ADMIN_R
];

export const dataKeyMap: Record<string, string> = {
  clientGraph: 'clientData',
  userGraph: 'userData',
  activeUserGraph: 'activeUserData',
  dashboardGraph: 'dashBoardData',
  viewGraph: 'viewData',
  queriesGraph: 'queryData',
  computeTimeGraph: 'computeTimeData',
  productDataGraph: 'productData',
  productViewGraph: 'productView',
  productQueryGraph: 'productQuery',
  productComputeTimeGraph: 'productComputeTime'
};

export const productId = {
  [LocusProducts.Person]: '80a5f1a0-a143-486e-aeae-12cd14eccc89',
  [LocusProducts.Transit_Insights]: 'acf132f2-b848-488d-af1a-f0b3889f0dc7',
  [LocusProducts.Truck]: '3bd7beb6-1d3b-4c96-847a-b363c70a3460',
  [LocusProducts.PersonPlus]: 'ff92a96a-9ddc-46df-8d68-05d9e19292ae',
  [LocusProducts.Transit_Insights_Lite]: '32a8c78b-0c2e-44b4-862d-5661b0cecc34',
  [LocusProducts.Perform]: 'a174a2e8-82e8-4acb-abd8-3cc7f4ddad1b'
};

export const tabTypes = {
  STATISTICS: 'statistics',
  TRENDS: 'trends',
  DESCRIPTION: 'description',
  RELEASE_POPUP: 'releasePopup',
  DETAILS: 'details',
  WHATS_NEW: 'whatsNew',
  REGULAR: 'regular',
  TRIAL: 'trial',
  RELEASE_ITEMS: 'releaseItems',
  USERS: 'users',
  INSIGHTS: 'insights',
  ALL_CLIENTS: 'allClients',
  ACTIVE_CLIENTS: 'activeClients',
  EXPIRED_CLIENTS: 'expiredClients'
};

export const graphColor = {
  fill: '#6495ED',
  stroke: 'blue'
};

export const months = [
  'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
  'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
];

export const getBarColor = (key: string) => {
  const colorMap: Record<string, string> = {
    person: '#6495ED',
    truck: '#ef476f',
    transit_insights: '#f77f00',
    'person+': '#06d6a0',
    perform: '#d450eb'
  };
  return colorMap[key] || '#ccc';
};

export const relatedGraphs: any = {
  productDataGraph: ['dashboardGraph'],
  dashboardGraph: ['productDataGraph'],
  productViewGraph: ['viewGraph'],
  viewGraph: ['productViewGraph'],
  productQueryGraph: ['queriesGraph'],
  queriesGraph: ['productQueryGraph'],
  productComputeTimeGraph: ['computeTimeGraph'],
  computeTimeGraph: ['productComputeTimeGraph']
};

export const graphKeys = [
  'activeUserGraph',
  'dashboardGraph',
  'viewGraph',
  'queriesGraph',
  'computeTimeGraph',
  'productDataGraph',
  'productViewGraph',
  'productQueryGraph',
  'productComputeTimeGraph',
];

export const productKeys: any = {
  person: LocusProducts.Person,
  'person+': LocusProducts.PersonPlus,
  truck: LocusProducts.Truck,
  transit_insights: LocusProducts.Transit_Insights,
  transit_insights_lite: LocusProducts.Transit_Insights_Lite,
  perform: LocusProducts.Perform
};

export const mfaTypeOptions: any = {
  all: ['user', 'clientAdmin'],
  none: [],
  user: ['user'],
  clientAdmin: ['clientAdmin']
};

export const TransitLiteDashboardProductId = '32a8c78b-0c2e-44b4-862d-5661b0cecc34';

export const activeNavTypes = {
  signUpRequest: 'signUpRequestsCount',
  mapDataRequest: 'dataRequestsCount'
};

export const clientStatus: any = {
  active: 'Active',
  expired: 'Expired'
};

export const getOptions = (viewType: any) => {
  if (viewType === tabTypes.ALL_CLIENTS) {
    return [clientStatus.active, clientStatus.expired];
  }
  if (viewType === tabTypes.ACTIVE_CLIENTS) {
    return [clientStatus.active];
  }
  return [clientStatus.expired];
};

export const mapLayerTypes = {
  default: 'default',
  existing: 'existing',
  operational: 'operational'
};

export const productIdToName = Object.entries(productId).reduce((acc, [key, value]) => {
  let displayName = key;
  if (key === LocusProducts.Transit_Insights_Lite) {
    displayName = LocusProducts.Transit_Insights;
  }

  acc[value] = displayName;
  return acc;
}, {} as Record<string, string>);

export const DEFAULT_DASHBOARD_ID = process.env.REACT_APP_SUPERSET_DEFAULT_DASHBOARD;

export const viewSelectionOptions = {
  odView: 'OD View',
  itineraryView: 'Route / Itinerary View',
  comparison: 'Comparison',
  riderShipImpacts: 'RiderShip Impacts'
};

export const modulesCardList = [
  {
    name: viewSelectionOptions.odView,
    id: Object.keys(viewSelectionOptions)[0],
    desc: 'Understand travel markets and competitiveness of transit',
    disabled: true,
    icon: '/assets/images/od_view.png'
  },
  {
    name: viewSelectionOptions.itineraryView,
    id: Object.keys(viewSelectionOptions)[1],
    desc: 'Select itineraries and see travel markets served by them',
    icon: '/assets/images/itinerary_new_view.png'
  },
  {
    name: viewSelectionOptions.comparison,
    id: Object.keys(viewSelectionOptions)[2],
    desc: 'Compare study period and networks',
    icon: '/assets/images/comparison_view.svg'
  }
];

export const personNationalDatasetId = '21101d34-6c86-491c-9fff-50a10a3e0c32';
export const DAYS = [
  { id: 1, label: 'Monday' },
  { id: 2, label: 'Tuesday' },
  { id: 3, label: 'Wednesday' },
  { id: 4, label: 'Thursday' },
  { id: 5, label: 'Friday' },
  { id: 6, label: 'Saturday' },
  { id: 7, label: 'Sunday' }
];

export const ROUTE_COLORS = [
  '#0ea5e9',
  '#f97316',
  '#8b5cf6',
  '#10b981',
  '#ef4444',
  '#ec4899',
  '#14b8a6',
  '#eab308',
  '#6366f1',
  '#84cc16',
  '#f43f5e',
  '#22c55e',
  '#a855f7',
  '#06b6d4',
  '#f59e0b',
  '#d946ef',
  '#3b82f6',
  '#ef4444',
  '#16a34a',
  '#9333ea',
  '#0d9488',
  '#7c3aed',
  '#be123c',
  '#1d4ed8',
  '#65a30d',
  '#c026d3',
];

export const performanceReportTypes = {
  area: 'AREA',
  route: 'ROUTE',
  originDestination: 'ORIGIN_DESTINATION'
};

export const performanceReportTypeList = [
  {
    name: performanceReportTypes.route,
    id: performanceReportTypes.route,
    desc: 'Analyze speeds, travel times on selected routes',
  },
  {
    name: performanceReportTypes.area,
    id: performanceReportTypes.area,
    desc: 'Analyze speeds, travel times and traffic density, within selected area',
  }
];

export const performanceDateRangeLimit = {
  [performanceReportTypes.route]: 24,
  [performanceReportTypes.area]: 1,
  [performanceReportTypes.originDestination]: 4,
};

export const performanceReportODProductTypeList = [
  {
    name: 'Origin/Destination',
    id: performanceReportTypes.originDestination,
    desc: 'Analyze origin and destination of trips which started, passed through or ended within your defined regions.',
  },
  // For Future reference
  // {
  //   name: 'Selected Link',
  //   id: performanceReportTypes.selectedLink,
  //   desc: 'Analyze inbound and outbound trips through the selected road segment.',
  // }
];

export const originDestinationReportTypeList = [
  {
    name: 'Add to External Region',
    id: 'externalRegion',
    desc: 'Trips that starts or end outside of the defined regions are counted to the External region',
    passMatrix: false
  },
  {
    name: 'Trim to defined region',
    id: 'definedRegion',
    desc: `Trips will be terminated to defined regions. Origin of the trip will be defined
      as a region where trip was first seen and destination will be defined as a region where trip was last seen.`,
    passMatrix: true
  }
];
